/* globals jQuery */
import 'fitvids.1.1.0'

import './slideshows.js'
import responsiveNav from './responsive-nav.js'

(($) => {

    $.fn.responsiveNav = responsiveNav
    //$.fn.accordion = accordion

    const html = document.querySelector('html');
    html.classList.remove('no-js')
    html.classList.add('js');

    // Make nav menu nice & responsive
    const mainNav = document.querySelector('nav.main-nav');
    if( mainNav ){
        responsiveNav(mainNav,{
            navType: 'dropdown',
        });
    }

    // Responsive Videos
    $('.rtecontent, .video').fitVids();


})(jQuery)
